import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'app-excel-preview-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './excel-preview-dialog.component.html',
  styleUrl: './excel-preview-dialog.component.scss',
})
export class ExcelPreviewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ExcelPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { fileName: string; previewData: any[]; viewOnly: boolean }
  ) {}
}
